import { UploadIcon } from "@icons";
import { KickLogo } from "@design-system/KickLogo/KickLogo";
import { CardSection } from "@design-system/Card/CardSection";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useUpdateOrganizationMutation } from "@api/organization.api";
import { HStack } from "@design-system/HStack/HStack";
import settingsStyles from "./SettingsPage.module.scss";
import styles from "./LogoSection.module.scss";
import { useLogoUpload } from "./logoUpload.context";
import { LogoUpload } from "./LogoUpload";

export const LogoSection = () => {
    const activeOrganization = useActiveOrganization();
    const { open, rootProps, isUploading } = useLogoUpload();
    const updateOrganizationMutation = useUpdateOrganizationMutation();
    const hasLogo = !!activeOrganization?.logoUrl;

    return (
        <CardSection className={settingsStyles.section} {...rootProps}>
            <main>
                <header className={settingsStyles.sectionHeader}>
                    Firm logo
                </header>

                <div className={styles.logoPreview}>
                    {activeOrganization?.logoUrl ? (
                        <img
                            src={encodeURI(activeOrganization.logoUrl)}
                            alt="Firm logo"
                            className={styles.logo}
                        />
                    ) : (
                        <KickLogo variant="icon" shape="circle" size="2xl" />
                    )}
                </div>
            </main>

            <HStack as="aside" justify="end" gap={12}>
                {hasLogo && (
                    <ButtonWithLoader
                        loading={updateOrganizationMutation.isPending}
                        variant="primary"
                        size="md"
                        onClick={() =>
                            updateOrganizationMutation.mutate({
                                organizationId: activeOrganization?.id ?? "",
                                payload: { logoUrl: null },
                            })
                        }
                    >
                        Remove
                    </ButtonWithLoader>
                )}
                <LogoUpload>
                    <ButtonWithLoader
                        loading={isUploading}
                        variant="primary"
                        size="md"
                        leftIcon={<UploadIcon />}
                        onClick={open}
                    >
                        Upload logo
                    </ButtonWithLoader>
                </LogoUpload>
            </HStack>
        </CardSection>
    );
};
